import React, { useEffect, useState } from 'react';
import { deliveryStoreGoodsListCount, loadDeliveryStoreGoodsList } from '../api/store';
import ProductCard from '../components/store/store_product_list/ProductCard';
import ProductGrid2by2 from '../components/store/store_product_list/ProductGrid2by2';
import ProductList from '../components/store/store_product_list/ProductList';
import CategoryBar from '../components/util/CategoryBar';
import './StorePage.css';

const StorePageDeliveryGoods = () => {
  const [totalCount, setTotalCount] = useState(-1);
  const categories = [
    { id: 1, name: '스토어 홈', storeType: 'home' },
    { id: 2, name: '일반상품', storeType: 'normal' },
    { id: 3, name: '정기배송', storeType: 'delivery' },
    { id: 4, name: 'MY❤️', storeType: 'myInterest' },
  ];

  useEffect(() => {
    deliveryStoreGoodsListCount().then(res => setTotalCount(res.count));
  }, []);

  if (totalCount === -1) {
    return (
      <div className="container">
        {/* Header 제거됨 */}
        <CategoryBar categories={categories} currentCategory={'delivery'} />
      </div>
    );
  }
  return (
    <div className="container">
      <CategoryBar categories={categories} currentCategory={'delivery'} />
      <ProductList
        fetchData={loadDeliveryStoreGoodsList}
        totalData={totalCount}
        dataPerFetch={8}
        ItemComponent={ProductCard}
        GridComponent={ProductGrid2by2}
      />
    </div>
  );
};

export default StorePageDeliveryGoods;
